
import Vue, {PropType} from "vue";
//import axios from "axios";
import { UserMessage, UserMessagePriority }  from '../../../types/Sapphire_dto';
import axios from "axios";

export default Vue.extend({
    name: "message-list-item",
    props: {
        message: Object as PropType<UserMessage>,
        usr: String,
        fac: String
    },
    computed: {
        formattedDateSent(): string {
            let options: Intl.DateTimeFormatOptions = {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                timeZone: 'America/New_York',
                timeZoneName: "short",
            };
            return new Intl.DateTimeFormat("en-us", options).format(this.message.DateSent);
            //return new Intl.DateTimeFormat("en-us", options).format(new Date());
        }
    },
    data: function () {
    return {
        UserMessagePriority,
      };
    },
    methods: {
        async showMessage(msg: UserMessage) {
            this.$emit('viewer', msg);
            if ((msg.RecipientReadDate > new Date(1800, 0, 1)) == false) {
                let response = await axios.post("../../Common/Services/EmarClientOperations.svc/SetMessageAsRead",
                {
                    messageID: msg.MessageID,
                    userID: this.usr,
                    facilityID: this.fac
                });                
                
                msg.RecipientReadDate = response.data.d;
                // $.ajax({
                //     type: "POST",
                //     contentType: "application/json; charset=utf-8",
                //     url: "../../Common/Services/EmarClientOperations.svc/SetMessageAsRead",
                //     data: JSON.stringify({
                //         messageID: msg._MessageID,
                //         userID: vm.usr,
                //         facilityID: vm.fac
                //     }),
                //     processData: false,
                //     dataType: "json"
                // }).done(function (response) {
                //     var returnData = response.d;
                //     msg._RecipientReadDate = returnData;
                // }).fail(function (a, b, c) {
                //     swal('Error', 'There was an error marking the message as read.', 'error');
                // });
            }
        },
        formatUserName: function (item: UserMessage) {
            return String.stringFormat("{0} {1}", item.SenderFirstName, item.SenderLastName);
        },
    },
})
